<div class="loading">
  <mat-progress-spinner
    [strokeWidth]="strokeWidth"
    [diameter]="diameter"
    mode="indeterminate"
  ></mat-progress-spinner>
  <span>Carregando...</span>
</div>
